import useAuth from "./auth";

const useFeatures = () => {
  const [{ auth }] = useAuth();
 
  return auth?.tenant === 'zettablock.com'
}

export default useFeatures;